import React from "react";
import { Outlet } from "react-router-dom";
import { useOutletContext } from "react-router-dom";

export default function Admin() {
  const { chatUrl, isInfoPending, responseInfo } = useOutletContext();

  return (
    <div className="main">
      <Outlet context={{ chatUrl, isInfoPending, responseInfo }} />
    </div>
  );
}
